import type { ButtonProps } from "@chakra-ui/react";
import type { TrackProps } from "~/ui/tracked/types";
import { Button } from "~/ui/tracked/form/button";

export function PrimaryBtn(props: ButtonProps & TrackProps): JSX.Element {
  return <Button colorScheme="rose" {...props} />;
}
